import { render, staticRenderFns } from "./LogoutPrompt.vue?vue&type=template&id=24b3cfc2&scoped=true&"
import script from "./LogoutPrompt.vue?vue&type=script&lang=js&"
export * from "./LogoutPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3cfc2",
  null
  
)

export default component.exports